import { Button, Tooltip } from '@mui/material';
import { ReactElement } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { AnalyticsTriggerElementProps } from '@common/types';

interface TooltipButtonProps {
  onClick: () => void;
  disabled: boolean;
  label: string;
  tooltip?: string;
  testId?: string;
}

export function TooltipButton({
  onClick,
  disabled,
  label,
  tooltip,
  testId,
  ...analyticsProps
}: TooltipButtonProps & AnalyticsTriggerElementProps) {
  const ButtonWrapper = ({ children }: { children: ReactElement }) =>
    disabled ? <Tooltip title={tooltip}>{children}</Tooltip> : <Fragment>{children}</Fragment>;

  return (
    <ButtonWrapper>
      <div>
        <Button
          onClick={onClick}
          variant="contained"
          color="primary"
          disabled={disabled}
          data-testid={testId}
          {...analyticsProps}
        >
          {label}
        </Button>
      </div>
    </ButtonWrapper>
  );
}
